<app-dashboard>
  <div class="w-full flex flex-col gap-[30px] p-[20px]">
    <div class="w-full flex justify-end">
      <app-button
        [label]="'New API Key'"
        (onClick)="openAddModal()"
        [className]="
          'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
    <div *ngIf="fetchingData" class="w-full flex flex-col gap-[10px]">
      <div class="bg-slate-100 w-full rounded-[10px] h-[70px] animate-pulse"></div>
      <div class="bg-slate-100 w-full rounded-[10px] h-[70px] animate-pulse"></div>
    </div>
   <div class="w-full flex flex-col gap-[10px]">
    <ng-container *ngFor="let apiKey of apiKeys">
      <div  *ngIf="!fetchingData" class="webhook-card">
        <div class="name-section">
          <span class="name">{{apiKey?.name}}</span>
          <span class="type">Expires: {{formatDate(apiKey?.duration)}}</span>
        </div>
        <div class="middle">
          <span class="title"
            >IP Address:<span class="data">{{apiKey?.ipAddresses}}</span></span
          >
        </div>
        <div class="end">
          <div (click)="openDeleteModal(apiKey?._id)" class="icon-delete"></div>
        </div>
      </div>
    </ng-container>
   </div>
  </div>
</app-dashboard>
<app-modal
  [title]="'Create New API Key'"
  [isOpen]="addModalOpen"
  (closeModalEvent)="closeAddModal()"
>
  <div *ngIf="!apiKeyCreated" class="w-full flex flex-col">
    <app-input (returnValue)="setApiName($event)" [error]="errors.name" [label]="'Name'" [placeholder]="'Enter name'" />
    <app-input [label]="'IP Address(es)'" (returnValue)="setIpAddresses($event)" [placeholder]="'10.0.3.232'" />
    <app-dropdown [label]="'Expiry Date'" [placeholder]="'1 month'" [error]="errors.expiresIn" (selectedValue)="setApiExpiry($event)" [items]="durationOptions" />
    <app-button
      [label]="'Create Key'"
      [loading]="loading"
      (onClick)="createApiKey()"
      [className]="
        'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
      "
    ></app-button>
  </div>
  <div *ngIf="apiKeyCreated">
    <p class="form-subheading">API Key generated successfully!</p>
    <span class="extra-text">Please copy and save the generated API Key below. Once this modal is closed, It won't be displayed again.</span>
    <app-copy-text [text]="this.generatedApiKey"></app-copy-text>
</div>
</app-modal>
<app-modal
  [title]="'Create New API Key'"
  [isOpen]="deleteModalOpen"
  (closeModalEvent)="closeDeleteModal()"
>
  <div class="flex flex-col w-full gap-[30px] items-center">
    <span class="text-slate-800 text-[14px]">Delete this API Key?</span>
    <div class="w-full grid grid-cols-2 gap-[25px]">
      <app-button
        [label]="'Close Modal'"
        (onClick)="closeDeleteModal()"
        [className]="
          'text-[#081A46] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] border border-[#081A46]'
        "
      ></app-button>
      <app-button
        [label]="'Delete Key'"
        (onClick)="deleteApi()"
        [loading]="loading"
        [className]="
          'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
        "
      ></app-button>
    </div>
  </div>
</app-modal>
